import React from 'react';
import {observer} from 'mobx-react';
import {stylesheet} from 'typestyle';
import {px} from 'csx';
import {Store, AnalyticsTab} from '../../stores/store';
import {InsightsTableMode} from '../../stores/InsightsTableStore';
import {I18n} from '../../i18n/i18n';

interface CellDropdownProps {
    store: Store;
}

@observer
export default class CellDropdownList extends React.Component<CellDropdownProps> {
    public openSessionsModal = () => {
        const {
            channelStore: {selectedChannel},
            selectorTableStore: {cellAttributeContextMenu},
            insightsTableStore,
        } = this.props.store;

        if (cellAttributeContextMenu !== null) {
            const {primary, secondary, tab, sessionApiKey} = cellAttributeContextMenu;
            insightsTableStore.openInsightsModalAndLoadData({
                primary: primary || '',
                secondary,
                sessionApiKey,
                tab,
                channel: selectedChannel,
                mode:
                    this.props.store.activeAnalyticsTab === AnalyticsTab.SearchView
                        ? InsightsTableMode.ProductsForSearchTerm
                        : InsightsTableMode.SearchTermsForProduct,
            });
        }
    };

    private getDropdownOptions(): Array<{title: React.ReactNode; onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void}> {
        const {compareStore, activeAnalyticsTab} = this.props.store;

        if (compareStore.compareIsEnabled) {
            return [];
        }

        switch (activeAnalyticsTab) {
            case AnalyticsTab.ProductView:
                return [
                    {
                        title: <I18n i18nKey="insights:showSearchtermsForProduct" />,
                        onClick: this.openSessionsModal,
                    },
                ];
            case AnalyticsTab.SearchView:
                return [
                    {
                        title: <I18n i18nKey="insights:showProductsForSearchterm" />,
                        onClick: this.openSessionsModal,
                    },
                ];
            default:
                throw Error('Cannot open Cell Dropdown Option for ' + activeAnalyticsTab);
        }
    }

    public render() {
        const {
            store: {selectorTableStore},
        } = this.props;
        if (selectorTableStore.cellAttributeContextMenu === null) {
            return null;
        }
        const dropdownOptions = this.getDropdownOptions();

        if (dropdownOptions.length === 0) {
            return null;
        }

        return (
            <div
                className={dropdownCss.container + ' dropdown-menu'}
                style={{
                    top: selectorTableStore.cellAttributeContextMenu.y + 20,
                    left: selectorTableStore.cellAttributeContextMenu.x,
                }}>
                {dropdownOptions.map(({title, onClick}, index) => (
                    <a key={index} className={dropdownCss.item + ' dropdown-item'} onClick={onClick} href="javascript:void(0)">
                        {title}
                    </a>
                ))}
            </div>
        );
    }
}

const dropdownCss = stylesheet({
    container: {
        position: 'absolute',
        display: 'block',
        borderRadius: 2,
        padding: 0,
    },
    item: {
        paddingLeft: 5,
        paddingRight: 5,
        fontSize: px(13),
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/CellDropdownList.tsx